import React, { Fragment, Suspense, lazy, useState, useEffect } from "react";
import { ThemeProvider, StyledEngineProvider, CssBaseline } from "@mui/material";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import theme from "./theme";
import GlobalStyles from "./GlobalStyles";
import ReactGA from 'react-ga4';
import { getCurrentUser } from 'aws-amplify/auth';

// import Pace from "./shared/components/Pace";

import Home from "./Pages/home/Home/Home";
import Auth from "./Pages/Authentication/Auth";
import Tos from "./Pages/Tos/Tos";
import Portal from "./Pages/Portal/Portal";

if (`${process.env.REACT_APP_ENV}` === 'production'){
  ReactGA.initialize("G-LWES1S3VQV");

  // ReactGA.pageview(window.location.pathname);
  ReactGA.send({ hitType: "pageview", page: window.location.pathname});
}else{
  console.log("current env", `${process.env.REACT_APP_ENV}`);
}
// <Pace color={theme.palette.primary.light} />

function PrivateRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const checkAuthentication = async () => {
      try {
        await getCurrentUser();
        setIsAuthenticated(true); // User is authenticated
      } catch {
        setIsAuthenticated(false); // User is not authenticated
      }
    };

    checkAuthentication();
  }, []);

  if (isAuthenticated === null) {
    return <div>Loading...</div>; // Show loading while checking authentication
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" />;
  }

  return children;
};

function PublicRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const checkAuthentication = async () => {
      try {
        await getCurrentUser();
        setIsAuthenticated(true); // User is authenticated
      } catch {
        setIsAuthenticated(false); // User is not authenticated
      }
    };

    checkAuthentication();
  }, []);

  if (isAuthenticated) {
    return <Navigate to="/portal" />;
  }

  return children;
}

// function PrivateRoute({ children }) {
//   const [isAuthenticated, setIsAuthenticated] = useState(null);

//   if (!isAuthenticated) {
//     return <Navigate to="/auth/register" />;
//   }
//   return children;
// }


function App() {
  return (
    <BrowserRouter>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <GlobalStyles />

          <Suspense fallback={<Fragment />}>
            <Routes>
              {/* <Route path="/c" element={<LoggedInComponent />} /> */}
              <Route path="*" element={<Navigate to="/auth/register" />} />
              <Route path="/" element={<Home />} />
              <Route path="/auth/:authentication" element={
                  <PublicRoute>
                    <Auth />
                  </PublicRoute>
                }  
              />
              <Route path="/tos" element={<Tos />} />
              <Route 
                path="/portal" 
                element={
                <PrivateRoute>
                  <Portal />
                </PrivateRoute>
                } 
              />
            </Routes>
          </Suspense>
        </ThemeProvider>
      </StyledEngineProvider>
    </BrowserRouter>
  );
}

export default App;
